<template>
    <div>
        <h1>보유 포인트 조회</h1>

        <section class="mt-4">
            <div>
                <b>1. this.$store.dispatch("getUser")</b>
                <p>회원정보를 로드/리로드합니다. 회원정보 안에 포인트정보(point)가 포함되어 있습니다.</p>
            </div>

            <div>
                <b>2. this.$store.state.user</b>
                <p>1에서 로드한 회원정보에 접근하는 방법입니다. <br />computed 안에 리네임 형태로 사용하는 편이 작업시간을 절약 할 수 있습니다. <br />아래 예제에서는 me로 단축해서 사용합니다.</p>
            </div>

            <div>
                <b>* 기타</b>
                <p>예제에서는 비회원이거나 회원정보가 로드되지 않아 정보가 없을때 에러방지를 위해,<br /> ?(Optional Chaining) 접근 방법으로 포인트를 표시하고 있습니다.<br /> format 함수를 제거하면 금액 쉼표 없이 숫자만 표시 할 수 있습니다.</p>
            </div>

            <example-layout class="overflow-auto mt-8">
                <template v-slot:render>
                    <example-my-point />
                </template>
                
                <template v-slot:editor>
                    <prism-editor v-model="section1.exampleCode" line-numbers class="rounded"></prism-editor>
                </template>
            </example-layout>
        </section>
    </div>
</template>

<script>
import exampleLayout from '@/components/developer/example-layout.vue'
import prismEditor from '@/components/developer/prism-editor.vue'

import exampleMyPoint from '@/components/developer/me/example-my-point.vue'

export default {
    components: {
        exampleLayout,
        prismEditor,

        exampleMyPoint
    },
    data(){
        return {
            section1: {
                exampleCode: `<template>\n    <div>\n        <div>\n            <h4>\n                <span>상태: </span>\n                <span v-if=\"logOn\">로그인 상태입니다</span>\n                <span v-if=\"logOff\">로그아웃 상태입니다</span>\n            </h4>\n        </div>\n        \n        <div class=\"mt-2\">\n            <span>보유포인트: {{ me?.point?.format?.() || 0 }}원</span>\n        </div>\n\n        <div class=\"mt-2\">\n            <v-btn color=\"primary\" @click=\"init()\">\n                <v-icon left size=\"20\">mdi-refresh</v-icon>\n                새로고침\n            </v-btn>\n        </div>\n    </div>\n</template>\n\n<script>\nimport api from \"@/api\";\nexport default {\n    mounted(){\n        this.init();\n    },\n    methods: {\n        async init(){\n            await this.$store.dispatch(\"getUser\");\n        }\n    },\n    computed: {\n        me(){ return this.$store.state.user; },\n        logOn(){ return !!this.$store.state.accessToken; },\n        logOff(){ return !this.$store.state.accessToken; },\n    }\n}\n<\/script>`
            }
        }
    },
}
</script>